// Сервис для управления авторизацией
class AuthService {
  private static instance: AuthService;
  private authDialogCallback: ((mode: 'login' | 'register' | 'restore') => void) | null = null;
  private isAppInitializing: boolean = true;

  private constructor() {}

  public static getInstance(): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }
    return AuthService.instance;
  }

  public setAuthDialogCallback(callback: (mode: 'login' | 'register' | 'restore') => void) {
    this.authDialogCallback = callback;
  }

  public setAppInitialized() {
    this.isAppInitializing = false;
  }

  public openAuthDialog(mode: 'login' | 'register' | 'restore' = 'login') {
    // Не показываем диалог во время инициализации приложения
    if (this.isAppInitializing) {
      console.log('App is still initializing, skipping auth dialog');
      return;
    }

    if (this.authDialogCallback) {
      this.authDialogCallback(mode);
    } else {
      // Fallback: перенаправление на страницу входа
      window.location.href = '/login';
    }
  }

  public clearTokens() {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    // Создаем anonymousId только если его нет
    if (!localStorage.getItem('anonymousId')) {
      const newAnonymousId = crypto.randomUUID();
      localStorage.setItem('anonymousId', newAnonymousId);
    }
  }
}

export default AuthService.getInstance();
